﻿import { logger } from '@fe/core';
import React from 'react';
import { MessageType } from '../../../../services/actor-messages';
import WorkspaceItemContext from '../../../contexts/workspace/workspace-item-context';
import { useAppSelector } from '../../../hooks/store-hooks';
import { useFlightWorker } from '../../../hooks/use-flight-worker';
import { EventBus } from '../../../contexts/event-bus';

export default function DiversionLayer() {
    const context = React.useContext(WorkspaceItemContext);
    const show = useAppSelector((x) => x.settings.diversionShowOnMap);
    const worker = useFlightWorker();

    React.useEffect(() => {
        context.diversionLayer.setShow(show);
    }, [show]);

    React.useEffect(() => {
        worker.actor
            .sendAsync({
                type: MessageType.getDiversionAirports
            })
            .then((x) => context.diversionLayer.update(x));

        // TODO: actor can only have 1 registered message handler, this doesn't work  with multiple workspace maps
        // Go though app for now
        return EventBus.on('diversion-record-updated', () => {
            logger.info('Diversion airports changed');
            worker.actor
                .sendAsync({
                    type: MessageType.getDiversionAirports
                })
                .then((x) => context.diversionLayer.update(x));

            return Promise.resolve();
        }).unsubscribe;
    }, [worker]);

    return <></>;
}
